import React from "react";
import { Icon } from "../core/Icon";

export function StatPill({ icon, value, label, live = false, tone = "gold" }) {
  const skins = {
    gold: { background: "var(--hive)", color: "var(--text-on-primary)" },
    quiet: { background: "var(--surface-muted)", color: "var(--text-body)" },
    inverse: { background: "var(--surface-inverse)", color: "var(--text-inverse)" },
  };
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "10px",
      borderRadius: "var(--radius-pill)", padding: "8px 16px",
      fontFamily: "var(--font-display)", fontWeight: "var(--weight-bold)",
      fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-wide)",
      boxShadow: "var(--shadow-medium)", ...skins[tone],
    }}>
      {live && (
        <span style={{ position: "relative", display: "inline-flex", width: 10, height: 10 }}>
          <span style={{
            position: "absolute", inset: 0, borderRadius: "var(--radius-pill)",
            background: "var(--success)", opacity: .75, animation: "fixy-ping 1s cubic-bezier(0,0,.2,1) infinite",
          }} />
          <span style={{ position: "relative", width: 10, height: 10, borderRadius: "var(--radius-pill)", background: "var(--success)" }} />
        </span>
      )}
      {icon && <Icon name={icon} size={15} />}
      {value && <span style={{ fontFamily: "var(--font-mono)" }}>{value}</span>}
      {label}
    </span>
  );
}
